import { connect } from 'react-redux'

import SampleForm from '../../../components/FieldsComponents/SampleForm/SampleForm'

import { closeSampleLocationMode, openSampleLocationMode } from '../../../actions/viewmode'
import {
  postPatchSample,
  setSampleFormType,
  resetAndCloseSampleForm,
  resetSampleFormPicturePath,
  setSampleFormExtraParameters
} from '../../../actions/samplesForm'
import { getS3Url } from '../../../actions/utilities'

import { getSamplesParametersByType, getSampleTypes } from '@layers-frontend/commons/store/selectors/sampleTypes'

import {
  formattedOptionsOfSampleExtraParameters,
  formattedOptionsOfSelectedSampleExtraParameters,
  getSampleFormExtraParameterById
} from '../../../selectors/sampleForm'
import { getSamplesFormImagePath, isNewSampleMode } from '../../../selectors/samplesForm'
import { getSelectedFlightGroupDeliverables, getSelectedFlightGroupFirstVisibleDeliverable } from '../../../selectors/flightGroups'
import { getDeliverablesTypesNameById } from '../../../selectors/deliverables'

import { setFormField, removeSampleFormExtraParam, setSampleFormExtraParamValueById } from '@layers-frontend/commons/store/actions/samplesForm'
import {
  getSamplesFormExtraParameters,
  getSamplesFormExtraParametersOrder,
  getSamplesFormBaseLayerId,
  getSamplesFormLocation,
  getSamplesFormNotes,
  getSamplesFormSampleCreationDate,
  getSamplesFormType,
  getSamplesFormPictureTempPath
} from '@layers-frontend/commons/store/selectors/samplesForm'

const mapStateToProps = state => ({
  type: getSamplesFormType(state),
  location: getSamplesFormLocation(state),
  extraParameters: getSamplesFormExtraParameters(state),
  pictureTempPath: getSamplesFormPictureTempPath(state),
  sampleTypes: getSampleTypes(state),
  selectedFlightGroupFirstVisibleDeliverable: getSelectedFlightGroupFirstVisibleDeliverable(state),
  selectedFlightGroupDeliverables: getSelectedFlightGroupDeliverables(state),
  extraParametersOrder: getSamplesFormExtraParametersOrder(state),
  parametersByType: getSamplesParametersByType(state),
  sampleExtraParameters: formattedOptionsOfSampleExtraParameters(state),
  getSampleFormExtraParameterById: getSampleFormExtraParameterById(state),
  picturePath: getSamplesFormImagePath(state),
  selectedSampleExtraParameters: formattedOptionsOfSelectedSampleExtraParameters(state),
  sampleCreationDate: getSamplesFormSampleCreationDate(state),
  notes: getSamplesFormNotes(state),
  baseLayer: getSamplesFormBaseLayerId(state),
  getDeliverablesTypesNameById: getDeliverablesTypesNameById(state),
  isNewSampleMode: isNewSampleMode(state)
})

const mapDispatchToProps = {
  setFormField,
  setSampleFormExtraParameters,
  setSampleFormExtraParamValueById,
  removeSampleFormExtraParam,
  openSampleLocationMode,
  setSampleFormType,
  closeSampleLocationMode,
  resetAndCloseSampleForm,
  postPatchSample,
  resetSampleFormPicturePath,
  getS3Url
}

export default connect(mapStateToProps, mapDispatchToProps)(SampleForm)
